import { IonImg, IonModal } from "@ionic/react";
import React, { useState } from "react";
import EditExercisesModal from "../components/modals/EditExercisesModal";
import DeleteExerciseModal from "../components/modals/delete-exercise-modal";

interface Props {
  exercise: any;
}

const DuplicateExercisesCard: React.FC<Props> = ({ exercise }) => {
  const [editExerciseModal, setEditExerciseModal] = useState(false);
  const [deleteExerciseModal, setDeleteExerciseModal] = useState(false);
  const [editExerciseId, setEditExerciseId] = useState(0);
  const [deleteExerciseId, setDeleteExerciseId] = useState(0);
  const {
    noOfSets,
    repsOrDuration,
    weight,
    hold,
    noOfTimes,
    noOfDays,
    sideName,
    noOfWeeks,
  } = exercise.testExercises[0];

  return (
    <>
      <IonModal
        className="edit-exercise-modal-main-wrap"
        backdropDismiss={false}
        isOpen={editExerciseModal}
        placeholder={undefined}
        animated={false}
        // initialBreakpoint={0.75}
        // breakpoints={[0.1, 0.5, 0.9]}
      >
        <EditExercisesModal
          editExerciseModal={setEditExerciseModal}
          exerciseData={exercise}
          index={editExerciseId}
        ></EditExercisesModal>
      </IonModal>

      <IonModal
        className="all-generic-new-modal-center-main-wrap"
        backdropDismiss={false}
        isOpen={deleteExerciseModal}
        placeholder={undefined}
      >
        <DeleteExerciseModal
          setDeleteExerciseModal={setDeleteExerciseModal}
          exerciseData={exercise}
          id={deleteExerciseId}
        ></DeleteExerciseModal>
      </IonModal>

      <div className="exercise-main-card-wrap duplicate-exercise-main-card-wrap slide-in-right">
        <div className="img-sec">
          <IonImg
            src={exercise.testExercises[0].thumbnail}
            placeholder={undefined}
          ></IonImg>
        </div>
        <div className="text-sec">
          <h2>{exercise.testName}</h2>
          <ul>
            <li>
              {noOfSets > 0 && `${noOfSets} sets`}
              {noOfSets > 0 && repsOrDuration && " | "}
              {repsOrDuration &&
                `${repsOrDuration} reps ${
                  sideName ? `${sideName}` : "per side"
                }`}
            </li>

            <li>
              {weight > 0 && `Weight: ${weight} lbs.`}
              {weight > 0 && hold > 0 && " | "}
              {hold > 0 && `Hold: ${hold} sec.`}
            </li>

            <li>
              {noOfTimes > 0 && `${noOfTimes}x/day`}
              {noOfTimes > 0 && noOfDays > 0 && " | "}
              {noOfDays > 0 && `${noOfDays}x/week`}
              {noOfWeeks > 0 && " | "}
              {noOfWeeks > 0 &&
                `${noOfWeeks} ${noOfWeeks === 1 ? "week" : "weeks"}`}
            </li>
          </ul>
        </div>
        <div className="edit-and-cross-icon">
          <ul>
            <li
              onClick={() => {
                setEditExerciseId(exercise.testExercises[0].id);
                setEditExerciseModal(true);
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="12" cy="12" r="12" fill="#F6F6F6" />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M15.4323 11.9918L9.96814 17.456C9.85701 17.5671 9.70628 17.6295 9.54911 17.6295H6.96369C6.63641 17.6295 6.37109 17.3642 6.37109 17.0369V14.4515C6.37109 14.2943 6.43353 14.1436 6.54466 14.0325L13.8439 6.73324C14.3277 6.2494 15.1122 6.2494 15.596 6.73324L17.2674 8.40458C17.7512 8.88842 17.7512 9.67288 17.2674 10.1567L15.4382 11.9859C15.4373 11.9869 15.4363 11.9878 15.4353 11.9888C15.4343 11.9898 15.4333 11.9908 15.4323 11.9918ZM14.682 7.57129C14.7029 7.5503 14.737 7.5503 14.758 7.57129L16.4293 9.24263C16.4503 9.26363 16.4503 9.29767 16.4293 9.31867L15.0163 10.7317L13.2689 8.98436L14.682 7.57129ZM12.4308 9.82241L7.55628 14.697V16.4443H9.30365L14.1782 11.5698L12.4308 9.82241Z"
                  fill="#802392"
                />
              </svg>
            </li>
            <li>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                  setDeleteExerciseId(exercise.testExercises[0].id);
                  setDeleteExerciseModal(true);
                }}
              >
                <circle cx="12" cy="12" r="12" fill="#F6F6F6" />
                <path
                  d="M10.7037 10.1481C11.0719 10.1481 11.3704 10.4466 11.3704 10.8148L11.3704 14.9629C11.3704 15.3311 11.0719 15.6296 10.7037 15.6296C10.3355 15.6296 10.037 15.3311 10.037 14.9629L10.037 10.8148C10.037 10.4466 10.3355 10.1481 10.7037 10.1481Z"
                  fill="#802392"
                />
                <path
                  d="M13.0741 10.1481C13.4422 10.1481 13.7407 10.4466 13.7407 10.8148V14.9629C13.7407 15.3311 13.4422 15.6296 13.0741 15.6296C12.7059 15.6296 12.4074 15.3311 12.4074 14.9629V10.8148C12.4074 10.4466 12.7059 10.1481 13.0741 10.1481Z"
                  fill="#802392"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M10.1111 6C9.41568 6 8.85189 6.56379 8.85189 7.25926V7.77767H7.14811C6.77992 7.77767 6.48145 8.07615 6.48145 8.44434C6.48145 8.81253 6.77992 9.111 7.14811 9.111H7.66667V16.7406C7.66667 17.4361 8.23046 17.9999 8.92593 17.9999H14.8519C15.5473 17.9999 16.1111 17.4361 16.1111 16.7406V9.111H16.6296C16.9978 9.111 17.2963 8.81253 17.2963 8.44434C17.2963 8.07615 16.9978 7.77767 16.6296 7.77767H14.926V7.25926C14.926 6.56379 14.3622 6 13.6667 6H10.1111ZM9.50639 9.111C9.51044 9.11108 9.51449 9.11111 9.51856 9.11111H14.2593C14.2634 9.11111 14.2674 9.11108 14.2715 9.111H14.7778V16.6666H9V9.111H9.50639ZM13.5926 7.77767V7.33333H10.1852V7.77767H13.5926Z"
                  fill="#802392"
                />
              </svg>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default DuplicateExercisesCard;
